/**
 * Contrato comum de todos os motores (secao 5 da ESPECIFICACAO.md).
 *
 * Um motor e uma mecanica de interacao implementada em codigo. As tarefas sao
 * apenas configuracao em JSON — nunca coloque logica no JSON.
 *
 * Todo motor emite ao final, via concluir():
 *   { tarefa_id, eixo, banda, tentativas, concluiu }
 * para a tabela eventos_aprendizado.
 */

/**
 * Erro lancado por motor ainda nao implementado.
 * A mensagem e sempre em portugues e diz qual motor faltou e em que fase ele
 * entra, porque quem le esta mensagem no console nao le codigo.
 */
export class NaoImplementadoError extends Error {
  constructor(motor, fase) {
    super(
      `FAZENDA: o motor "${motor}" ainda nao foi implementado. ` +
        `Ele esta previsto para a ${fase} na secao 13 da ESPECIFICACAO.md. ` +
        `Nenhuma tarefa que use "${motor}" pode rodar antes disso.`
    );
    this.name = 'NaoImplementadoError';
    this.motor = motor;
    this.fase = fase;
  }
}

export class BaseEngine {
  /**
   * @param {object} ctx contexto do jogo: { cena, audio, input, estado, banda }
   */
  constructor(ctx) {
    this.ctx = ctx;
    this.tarefa = null;
    this.banda = null;
    this.tentativas = 0;
  }

  /** Monta a interacao na ancora da tarefa. */
  async iniciar(tarefa, banda) {
    this.tarefa = tarefa;
    this.banda = banda;
    this.tentativas = 0;
  }

  /** Chamado a cada quadro. dt em segundos. */
  atualizar(dt) {} // eslint-disable-line no-unused-vars

  /**
   * Aplica sucesso.mundo e devolve o evento de aprendizado.
   * D6 — nao existe "errado": concluiu descreve se a crianca terminou a tarefa,
   * nunca se ela acertou.
   */
  async concluir(resultado) {
    return {
      tarefa_id: this.tarefa?.id ?? null,
      eixo: this.tarefa?.eixo ?? null,
      banda: this.banda,
      tentativas: this.tentativas,
      concluiu: resultado?.concluiu ?? false,
    };
  }

  /** Limpa tudo. Sem vazamento de memoria. */
  descartar() {
    this.tarefa = null;
    this.banda = null;
  }
}
